import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { FieldBBErrorType } from '../fields/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const textAreaField = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.TEXT_AREA_FIELD>): CreatedBuildingBlock<
	typeof COMPONENT_TYPE.TEXT_AREA_FIELD
> =>
	createModel({
		type: COMPONENT_TYPE.TEXT_AREA_FIELD,
		editorProps: {
			[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
		},
		componentProps: {
			[UNIFORM_PROPS.fieldPlaceholder]: dictionary.TEXT_AREA_FIELD.fieldPlaceholder,
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.text.phColor]: 'rgba(0, 0, 0, 0.54)',
					},
				},
			},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.TEXT_AREA_FIELD>;
